<template>
    <v-card :loading="loading">
        <v-card-title>
                    <span class="title-modal">
                        Ativação Automática
                    </span>
        </v-card-title>
        <v-card-text>
            <terms-conditions :vehicles="vehicle" :user="user" type="termos_de_uso_ativacao_automatica_web"/>
            <div class="row">
                <button class="btn-blue mx-auto mt-5" @click.prevent="acceptTerms(vehicle)">
                    Aceitar
                </button>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import TermsConditions from "../views/LandingPage/components/TermsConditions";
    import axios from 'axios';
    export default {
        name: "AutomaticActivation",
        props: [
            'vehicle',
        ],
        components: {TermsConditions},
        data: function () {
            return {
                message_success: false,
                message_fail: false,
                loading: false,
                vehicles: []
            }
        },
        methods: {
            close: function () {
                this.$emit('close', false);
            },
            success: function () {
                this.$emit('success', false);
            },
            error: function () {
                this.$emit('error', false);
            },
            acceptTerms: async function (vehicles) {
                    let error = false;
                    for (let i = 0; vehicles.length > i; i++) {
                        if (!await this.activateAutomatic(vehicles[i], vehicles[i].wallet.id)) {
                            error = true;
                            break;
                        }
                    }
                    if (!error) {
                        this.success();
                    } else {
                        this.error();
                    }
            },
            activateAutomatic: async function (vehicle, wallet_id) {
                try {
                    await axios.put(`/api/vehicle/${vehicle.id}/automatic_activation`, {
                        automatic_activation: true
                    });
                    return true;
                } catch (e) {
                    return false;
                }
            }

        },
        computed: {
            user_id: function () {
                return JSON.parse(localStorage.getItem('user')).id;
            },
            user: function () {
                let ls = JSON.parse(localStorage.getItem('user'));
                return {name: ls.name, identification: ls.identification};
            }
        }
    }
</script>

<style scoped>
    .btn-blue {
        text-transform: capitalize !important;
        background: #000 !important;
        color: #ffffff !important;
        font-family: Roboto-Black !important;
        width: 120px;
        height: 43px !important;
        border-radius: 4px !important;
        padding: 8px 15px !important;
        border: 3px solid #000 !important;
    }

    .btn-blue:hover {
        background: transparent !important;
        color: #000 !important;
    }
</style>
